//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { SocketRulesEngineApiBase } from './SocketRulesEngineApi.base';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { DateTime, Duration } from "luxon";

export class AdminApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getTestConfigurations(  cancelToken?: CancelToken | undefined): Promise<AdminConfig> {
        let url_ = this.baseUrl + "/api/Admin/GetTestConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTestConfigurations(_response);
        });
    }

    protected processGetTestConfigurations(response: AxiosResponse): Promise<AdminConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminConfig.fromJS(resultData200);
            return Promise.resolve<AdminConfig>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminConfig>(null as any);
    }

    /**
     * @param clientName (optional) 
     * @param processorName (optional) 
     * @return Success
     */
    createClient(clientName?: string | undefined, processorName?: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Admin/CreateClient?";
        if (clientName === null)
            throw new Error("The parameter 'clientName' cannot be null.");
        else if (clientName !== undefined)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        if (processorName === null)
            throw new Error("The parameter 'processorName' cannot be null.");
        else if (processorName !== undefined)
            url_ += "processorName=" + encodeURIComponent("" + processorName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateClient(_response);
        });
    }

    protected processCreateClient(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    deleteClient(clientId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Admin/DeleteClient?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteClient(_response);
        });
    }

    protected processDeleteClient(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Creates a User, or assigns an existing User to a Client.
     * @param username (optional) Username of user.
     * @param clientName (optional) Name of Client.
     * @param forceMove (optional) Forces the movement of the user to the ClientName even if the user is already under another client.
     * @return Success
     */
    addOrAssignUserToClient(username?: string | undefined, clientName?: string | undefined, forceMove?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Admin/AddOrAssignUserToClient?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (clientName === null)
            throw new Error("The parameter 'clientName' cannot be null.");
        else if (clientName !== undefined)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        if (forceMove === null)
            throw new Error("The parameter 'forceMove' cannot be null.");
        else if (forceMove !== undefined)
            url_ += "forceMove=" + encodeURIComponent("" + forceMove) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrAssignUserToClient(_response);
        });
    }

    protected processAddOrAssignUserToClient(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param processorName (optional) 
     * @param jsonSchema (optional) 
     * @return Success
     */
    updateProcessor(processorName?: string | undefined, jsonSchema?: string | undefined , cancelToken?: CancelToken | undefined): Promise<RuleProcessor> {
        let url_ = this.baseUrl + "/api/Admin/UpdateProcessor?";
        if (processorName === null)
            throw new Error("The parameter 'processorName' cannot be null.");
        else if (processorName !== undefined)
            url_ += "processorName=" + encodeURIComponent("" + processorName) + "&";
        if (jsonSchema === null)
            throw new Error("The parameter 'jsonSchema' cannot be null.");
        else if (jsonSchema !== undefined)
            url_ += "jsonSchema=" + encodeURIComponent("" + jsonSchema) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProcessor(_response);
        });
    }

    protected processUpdateProcessor(response: AxiosResponse): Promise<RuleProcessor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleProcessor.fromJS(resultData200);
            return Promise.resolve<RuleProcessor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleProcessor>(null as any);
    }

    /**
     * @param username (optional) 
     * @return Success
     */
    markUserDeleted(username?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/MarkUserDeleted?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkUserDeleted(_response);
        });
    }

    protected processMarkUserDeleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param username (optional) 
     * @param oktaId (optional) 
     * @return Success
     */
    updateUserOktaId(username?: string | undefined, oktaId?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/UpdateUserOktaId?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (oktaId === null)
            throw new Error("The parameter 'oktaId' cannot be null.");
        else if (oktaId !== undefined)
            url_ += "oktaId=" + encodeURIComponent("" + oktaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserOktaId(_response);
        });
    }

    protected processUpdateUserOktaId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param includeOriginalData (optional) 
     * @param body (optional) 
     * @return Success
     */
    process(includeOriginalData?: boolean | undefined, body?: ProcessorRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProcessorResponseDto> {
        let url_ = this.baseUrl + "/api/Admin/Process?";
        if (includeOriginalData === null)
            throw new Error("The parameter 'includeOriginalData' cannot be null.");
        else if (includeOriginalData !== undefined)
            url_ += "includeOriginalData=" + encodeURIComponent("" + includeOriginalData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcess(_response);
        });
    }

    protected processProcess(response: AxiosResponse): Promise<ProcessorResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessorResponseDto.fromJS(resultData200);
            return Promise.resolve<ProcessorResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessorResponseDto>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    getOrCreateClientApiKeyUser(clientId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Admin/GetOrCreateClientApiKeyUser?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrCreateClientApiKeyUser(_response);
        });
    }

    protected processGetOrCreateClientApiKeyUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    extractClientData(clientId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<ClientDataExportDto> {
        let url_ = this.baseUrl + "/api/Admin/ExtractClientData?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtractClientData(_response);
        });
    }

    protected processExtractClientData(response: AxiosResponse): Promise<ClientDataExportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientDataExportDto.fromJS(resultData200);
            return Promise.resolve<ClientDataExportDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientDataExportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importClientData(body?: ClientDataExportDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Admin/ImportClientData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportClientData(_response);
        });
    }

    protected processImportClientData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ClientApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getClientFields(  cancelToken?: CancelToken | undefined): Promise<FieldDto[]> {
        let url_ = this.baseUrl + "/api/Client/GetClientFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientFields(_response);
        });
    }

    protected processGetClientFields(response: AxiosResponse): Promise<FieldDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FieldDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFieldTypeUsage(  cancelToken?: CancelToken | undefined): Promise<FieldTypeUsageDto[]> {
        let url_ = this.baseUrl + "/api/Client/GetFieldTypeUsage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFieldTypeUsage(_response);
        });
    }

    protected processGetFieldTypeUsage(response: AxiosResponse): Promise<FieldTypeUsageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldTypeUsageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FieldTypeUsageDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldTypeUsageDto[]>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    getDefaultRuleProcessor(clientId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProcessorPreviewDto> {
        let url_ = this.baseUrl + "/api/Client/GetDefaultRuleProcessor?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultRuleProcessor(_response);
        });
    }

    protected processGetDefaultRuleProcessor(response: AxiosResponse): Promise<ProcessorPreviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessorPreviewDto.fromJS(resultData200);
            return Promise.resolve<ProcessorPreviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessorPreviewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRuleProcessorFields(body?: FieldDto[] | undefined , cancelToken?: CancelToken | undefined): Promise<FieldDto[]> {
        let url_ = this.baseUrl + "/api/Client/UpdateRuleProcessorFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRuleProcessorFields(_response);
        });
    }

    protected processUpdateRuleProcessorFields(response: AxiosResponse): Promise<FieldDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FieldDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldDto[]>(null as any);
    }
}

export class LogsApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param pageSize (optional) 
     * @param skip (optional) 
     * @return Success
     */
    getRuleHistory(pageSize?: number | undefined, skip?: number | undefined , cancelToken?: CancelToken | undefined): Promise<ApiLogDtoPagedDataDto> {
        let url_ = this.baseUrl + "/api/Logs/GetRuleHistory?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuleHistory(_response);
        });
    }

    protected processGetRuleHistory(response: AxiosResponse): Promise<ApiLogDtoPagedDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiLogDtoPagedDataDto.fromJS(resultData200);
            return Promise.resolve<ApiLogDtoPagedDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiLogDtoPagedDataDto>(null as any);
    }
}

export class PreviewApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    getApiSampleData(clientId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Preview/GetApiSampleData?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApiSampleData(_response);
        });
    }

    protected processGetApiSampleData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @param sampleData (optional) 
     * @return Success
     */
    setApiSampleData(clientId?: number | undefined, sampleData?: string | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Preview/SetApiSampleData?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (sampleData === null)
            throw new Error("The parameter 'sampleData' cannot be null.");
        else if (sampleData !== undefined)
            url_ += "sampleData=" + encodeURIComponent("" + sampleData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetApiSampleData(_response);
        });
    }

    protected processSetApiSampleData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    clearApiSampleData(clientId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Preview/ClearApiSampleData?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearApiSampleData(_response);
        });
    }

    protected processClearApiSampleData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param includeOriginalData (optional) 
     * @param testPayload (optional) 
     * @param body (optional) 
     * @return Success
     */
    testProcess(includeOriginalData?: boolean | undefined, testPayload?: boolean | undefined, body?: ProcessorRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProcessorResponseDto> {
        let url_ = this.baseUrl + "/api/Preview/TestProcess?";
        if (includeOriginalData === null)
            throw new Error("The parameter 'includeOriginalData' cannot be null.");
        else if (includeOriginalData !== undefined)
            url_ += "includeOriginalData=" + encodeURIComponent("" + includeOriginalData) + "&";
        if (testPayload === null)
            throw new Error("The parameter 'testPayload' cannot be null.");
        else if (testPayload !== undefined)
            url_ += "testPayload=" + encodeURIComponent("" + testPayload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestProcess(_response);
        });
    }

    protected processTestProcess(response: AxiosResponse): Promise<ProcessorResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessorResponseDto.fromJS(resultData200);
            return Promise.resolve<ProcessorResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessorResponseDto>(null as any);
    }
}

export class RuleProcessorApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param includeOriginalData (optional) 
     * @param body (optional) 
     * @return Success
     */
    process(includeOriginalData?: boolean | undefined, body?: ProcessorRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProcessorResponseDto> {
        let url_ = this.baseUrl + "/socket/RuleProcessor/Process?";
        if (includeOriginalData === null)
            throw new Error("The parameter 'includeOriginalData' cannot be null.");
        else if (includeOriginalData !== undefined)
            url_ += "includeOriginalData=" + encodeURIComponent("" + includeOriginalData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcess(_response);
        });
    }

    protected processProcess(response: AxiosResponse): Promise<ProcessorResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessorResponseDto.fromJS(resultData200);
            return Promise.resolve<ProcessorResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProcessorResponseDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessorResponseDto>(null as any);
    }
}

export class RulesApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * API to get all rule groups for a client, used in the /rules page
     * @return Success
     */
    getRuleGroups(  cancelToken?: CancelToken | undefined): Promise<RuleGroupDisplayDto[]> {
        let url_ = this.baseUrl + "/api/Rules/GetRuleGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuleGroups(_response);
        });
    }

    protected processGetRuleGroups(response: AxiosResponse): Promise<RuleGroupDisplayDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleGroupDisplayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RuleGroupDisplayDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleGroupDisplayDto[]>(null as any);
    }

    /**
     * API to get a specific rule group for a client, used in the /rules/{id} page
     * @param ruleGroupUrl (optional) 
     * @return Success
     */
    getRuleGroup(ruleGroupUrl?: string | undefined , cancelToken?: CancelToken | undefined): Promise<RuleGroupDisplayDto> {
        let url_ = this.baseUrl + "/api/Rules/GetRuleGroup?";
        if (ruleGroupUrl === null)
            throw new Error("The parameter 'ruleGroupUrl' cannot be null.");
        else if (ruleGroupUrl !== undefined)
            url_ += "ruleGroupUrl=" + encodeURIComponent("" + ruleGroupUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuleGroup(_response);
        });
    }

    protected processGetRuleGroup(response: AxiosResponse): Promise<RuleGroupDisplayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleGroupDisplayDto.fromJS(resultData200);
            return Promise.resolve<RuleGroupDisplayDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleGroupDisplayDto>(null as any);
    }

    /**
     * API to get a specific rule group
     * @param ruleGroupId (optional) 
     * @return Success
     */
    getRuleGroupById(ruleGroupId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<RuleGroupDisplayDto> {
        let url_ = this.baseUrl + "/api/Rules/GetRuleGroupById?";
        if (ruleGroupId === null)
            throw new Error("The parameter 'ruleGroupId' cannot be null.");
        else if (ruleGroupId !== undefined)
            url_ += "ruleGroupId=" + encodeURIComponent("" + ruleGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuleGroupById(_response);
        });
    }

    protected processGetRuleGroupById(response: AxiosResponse): Promise<RuleGroupDisplayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleGroupDisplayDto.fromJS(resultData200);
            return Promise.resolve<RuleGroupDisplayDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleGroupDisplayDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRuleGroup(body?: UpdateRuleGroupDto | undefined , cancelToken?: CancelToken | undefined): Promise<RuleGroupDisplayDto> {
        let url_ = this.baseUrl + "/api/Rules/UpdateRuleGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRuleGroup(_response);
        });
    }

    protected processUpdateRuleGroup(response: AxiosResponse): Promise<RuleGroupDisplayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleGroupDisplayDto.fromJS(resultData200);
            return Promise.resolve<RuleGroupDisplayDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleGroupDisplayDto>(null as any);
    }

    /**
     * @param ruleGroupId (optional) 
     * @param newMarkup (optional) 
     * @return Success
     */
    updateDefaultMarkup(ruleGroupId?: number | undefined, newMarkup?: number | undefined , cancelToken?: CancelToken | undefined): Promise<RuleGroupDisplayDto> {
        let url_ = this.baseUrl + "/api/Rules/UpdateDefaultMarkup?";
        if (ruleGroupId === null)
            throw new Error("The parameter 'ruleGroupId' cannot be null.");
        else if (ruleGroupId !== undefined)
            url_ += "ruleGroupId=" + encodeURIComponent("" + ruleGroupId) + "&";
        if (newMarkup === null)
            throw new Error("The parameter 'newMarkup' cannot be null.");
        else if (newMarkup !== undefined)
            url_ += "newMarkup=" + encodeURIComponent("" + newMarkup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDefaultMarkup(_response);
        });
    }

    protected processUpdateDefaultMarkup(response: AxiosResponse): Promise<RuleGroupDisplayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleGroupDisplayDto.fromJS(resultData200);
            return Promise.resolve<RuleGroupDisplayDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleGroupDisplayDto>(null as any);
    }

    /**
     * @return Success
     */
    getRuleBuilderOptions(  cancelToken?: CancelToken | undefined): Promise<RuleBuilderOptionsDto> {
        let url_ = this.baseUrl + "/api/Rules/GetRuleBuilderOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuleBuilderOptions(_response);
        });
    }

    protected processGetRuleBuilderOptions(response: AxiosResponse): Promise<RuleBuilderOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleBuilderOptionsDto.fromJS(resultData200);
            return Promise.resolve<RuleBuilderOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleBuilderOptionsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRuleGroup(body?: CreateRuleGroupDto | undefined , cancelToken?: CancelToken | undefined): Promise<RuleGroupDisplayDto> {
        let url_ = this.baseUrl + "/api/Rules/CreateRuleGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRuleGroup(_response);
        });
    }

    protected processCreateRuleGroup(response: AxiosResponse): Promise<RuleGroupDisplayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleGroupDisplayDto.fromJS(resultData200);
            return Promise.resolve<RuleGroupDisplayDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleGroupDisplayDto>(null as any);
    }

    /**
     * @param ruleGroupId (optional) 
     * @return Success
     */
    deleteRuleGroup(ruleGroupId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Rules/DeleteRuleGroup?";
        if (ruleGroupId === null)
            throw new Error("The parameter 'ruleGroupId' cannot be null.");
        else if (ruleGroupId !== undefined)
            url_ += "ruleGroupId=" + encodeURIComponent("" + ruleGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRuleGroup(_response);
        });
    }

    protected processDeleteRuleGroup(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SetupApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param clientName (optional) 
     * @return Success
     */
    seedP44Client(clientName?: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Setup/SeedP44Client?";
        if (clientName === null)
            throw new Error("The parameter 'clientName' cannot be null.");
        else if (clientName !== undefined)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSeedP44Client(_response);
        });
    }

    protected processSeedP44Client(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UserApi extends SocketRulesEngineApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUser(userId?: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/GetUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param username (optional) 
     * @return Success
     */
    getUserByUsername(username?: string | undefined , cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/GetUserByUsername?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByUsername(_response);
        });
    }

    protected processGetUserByUsername(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserProfile(  cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/GetUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export class APILog implements IAPILog {
    id?: number;
    requestHeaders?: string | null;
    requestMadeOn?: DateTime;
    clientID?: number | null;
    client?: Client;
    requestBodyID?: number;
    requestBody?: APILogRequestBody;
    responseBodyID?: number | null;
    responseBody?: APILogResponseBody;
    errorID?: number | null;
    error?: APILogError;
    appliedRules?: Rule[] | null;
    metadata?: Metadata;
    timings?: { [key: string]: number; } | null;

    constructor(data?: IAPILog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.requestHeaders = _data["requestHeaders"] !== undefined ? _data["requestHeaders"] : <any>null;
            this.requestMadeOn = _data["requestMadeOn"] ? DateTime.fromISO(_data["requestMadeOn"].toString()) : <any>null;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.requestBodyID = _data["requestBodyID"] !== undefined ? _data["requestBodyID"] : <any>null;
            this.requestBody = _data["requestBody"] ? APILogRequestBody.fromJS(_data["requestBody"]) : <any>null;
            this.responseBodyID = _data["responseBodyID"] !== undefined ? _data["responseBodyID"] : <any>null;
            this.responseBody = _data["responseBody"] ? APILogResponseBody.fromJS(_data["responseBody"]) : <any>null;
            this.errorID = _data["errorID"] !== undefined ? _data["errorID"] : <any>null;
            this.error = _data["error"] ? APILogError.fromJS(_data["error"]) : <any>null;
            if (Array.isArray(_data["appliedRules"])) {
                this.appliedRules = [] as any;
                for (let item of _data["appliedRules"])
                    this.appliedRules!.push(Rule.fromJS(item));
            }
            else {
                this.appliedRules = <any>null;
            }
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            if (_data["timings"]) {
                this.timings = {} as any;
                for (let key in _data["timings"]) {
                    if (_data["timings"].hasOwnProperty(key))
                        (<any>this.timings)![key] = _data["timings"][key] !== undefined ? _data["timings"][key] : <any>null;
                }
            }
            else {
                this.timings = <any>null;
            }
        }
    }

    static fromJS(data: any): APILog {
        data = typeof data === 'object' ? data : {};
        let result = new APILog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["requestHeaders"] = this.requestHeaders !== undefined ? this.requestHeaders : <any>null;
        data["requestMadeOn"] = this.requestMadeOn ? this.requestMadeOn.toString() : <any>null;
        data["clientID"] = this.clientID !== undefined ? this.clientID : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["requestBodyID"] = this.requestBodyID !== undefined ? this.requestBodyID : <any>null;
        data["requestBody"] = this.requestBody ? this.requestBody.toJSON() : <any>null;
        data["responseBodyID"] = this.responseBodyID !== undefined ? this.responseBodyID : <any>null;
        data["responseBody"] = this.responseBody ? this.responseBody.toJSON() : <any>null;
        data["errorID"] = this.errorID !== undefined ? this.errorID : <any>null;
        data["error"] = this.error ? this.error.toJSON() : <any>null;
        if (Array.isArray(this.appliedRules)) {
            data["appliedRules"] = [];
            for (let item of this.appliedRules)
                data["appliedRules"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        if (this.timings) {
            data["timings"] = {};
            for (let key in this.timings) {
                if (this.timings.hasOwnProperty(key))
                    (<any>data["timings"])[key] = this.timings[key] !== undefined ? this.timings[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IAPILog {
    id?: number;
    requestHeaders?: string | null;
    requestMadeOn?: DateTime;
    clientID?: number | null;
    client?: Client;
    requestBodyID?: number;
    requestBody?: APILogRequestBody;
    responseBodyID?: number | null;
    responseBody?: APILogResponseBody;
    errorID?: number | null;
    error?: APILogError;
    appliedRules?: Rule[] | null;
    metadata?: Metadata;
    timings?: { [key: string]: number; } | null;
}

export class APILogError implements IAPILogError {
    id?: number;
    error?: string | null;

    constructor(data?: IAPILogError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
        }
    }

    static fromJS(data: any): APILogError {
        data = typeof data === 'object' ? data : {};
        let result = new APILogError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data;
    }
}

export interface IAPILogError {
    id?: number;
    error?: string | null;
}

export class APILogRequestBody implements IAPILogRequestBody {
    id?: number;
    requestBody?: string | null;

    constructor(data?: IAPILogRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.requestBody = _data["requestBody"] !== undefined ? _data["requestBody"] : <any>null;
        }
    }

    static fromJS(data: any): APILogRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new APILogRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["requestBody"] = this.requestBody !== undefined ? this.requestBody : <any>null;
        return data;
    }
}

export interface IAPILogRequestBody {
    id?: number;
    requestBody?: string | null;
}

export class APILogResponseBody implements IAPILogResponseBody {
    id?: number;
    responseBody?: string | null;

    constructor(data?: IAPILogResponseBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.responseBody = _data["responseBody"] !== undefined ? _data["responseBody"] : <any>null;
        }
    }

    static fromJS(data: any): APILogResponseBody {
        data = typeof data === 'object' ? data : {};
        let result = new APILogResponseBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["responseBody"] = this.responseBody !== undefined ? this.responseBody : <any>null;
        return data;
    }
}

export interface IAPILogResponseBody {
    id?: number;
    responseBody?: string | null;
}

export class AdminConfig implements IAdminConfig {
    env?: string | null;
    testValue?: string | null;
    oktaAppName?: string | null;
    enableSwagger?: boolean;

    constructor(data?: IAdminConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.env = _data["env"] !== undefined ? _data["env"] : <any>null;
            this.testValue = _data["testValue"] !== undefined ? _data["testValue"] : <any>null;
            this.oktaAppName = _data["oktaAppName"] !== undefined ? _data["oktaAppName"] : <any>null;
            this.enableSwagger = _data["enableSwagger"] !== undefined ? _data["enableSwagger"] : <any>null;
        }
    }

    static fromJS(data: any): AdminConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AdminConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["env"] = this.env !== undefined ? this.env : <any>null;
        data["testValue"] = this.testValue !== undefined ? this.testValue : <any>null;
        data["oktaAppName"] = this.oktaAppName !== undefined ? this.oktaAppName : <any>null;
        data["enableSwagger"] = this.enableSwagger !== undefined ? this.enableSwagger : <any>null;
        return data;
    }
}

export interface IAdminConfig {
    env?: string | null;
    testValue?: string | null;
    oktaAppName?: string | null;
    enableSwagger?: boolean;
}

export class ApiLogDto implements IApiLogDto {
    apiLogId?: number;
    readonly displayId?: string | null;
    metadata?: Metadata;
    requestDate?: DateTime;
    ruleDetails?: RuleLogDto;
    readonly conditionMatch?: string | null;

    constructor(data?: IApiLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiLogId = _data["apiLogId"] !== undefined ? _data["apiLogId"] : <any>null;
            (<any>this).displayId = _data["displayId"] !== undefined ? _data["displayId"] : <any>null;
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>null;
            this.requestDate = _data["requestDate"] ? DateTime.fromISO(_data["requestDate"].toString()) : <any>null;
            this.ruleDetails = _data["ruleDetails"] ? RuleLogDto.fromJS(_data["ruleDetails"]) : <any>null;
            (<any>this).conditionMatch = _data["conditionMatch"] !== undefined ? _data["conditionMatch"] : <any>null;
        }
    }

    static fromJS(data: any): ApiLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiLogId"] = this.apiLogId !== undefined ? this.apiLogId : <any>null;
        data["displayId"] = this.displayId !== undefined ? this.displayId : <any>null;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>null;
        data["requestDate"] = this.requestDate ? this.requestDate.toString() : <any>null;
        data["ruleDetails"] = this.ruleDetails ? this.ruleDetails.toJSON() : <any>null;
        data["conditionMatch"] = this.conditionMatch !== undefined ? this.conditionMatch : <any>null;
        return data;
    }
}

export interface IApiLogDto {
    apiLogId?: number;
    displayId?: string | null;
    metadata?: Metadata;
    requestDate?: DateTime;
    ruleDetails?: RuleLogDto;
    conditionMatch?: string | null;
}

export class ApiLogDtoPagedDataDto implements IApiLogDtoPagedDataDto {
    total?: number;
    currentPage?: ApiLogDto[] | null;

    constructor(data?: IApiLogDtoPagedDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            if (Array.isArray(_data["currentPage"])) {
                this.currentPage = [] as any;
                for (let item of _data["currentPage"])
                    this.currentPage!.push(ApiLogDto.fromJS(item));
            }
            else {
                this.currentPage = <any>null;
            }
        }
    }

    static fromJS(data: any): ApiLogDtoPagedDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiLogDtoPagedDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        if (Array.isArray(this.currentPage)) {
            data["currentPage"] = [];
            for (let item of this.currentPage)
                data["currentPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiLogDtoPagedDataDto {
    total?: number;
    currentPage?: ApiLogDto[] | null;
}

export class AppliedRulesDto implements IAppliedRulesDto {
    ruleGroupName?: string | null;
    modificationField?: string | null;
    readonly value?: string | null;
    readonly modification?: string | null;

    constructor(data?: IAppliedRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleGroupName = _data["ruleGroupName"] !== undefined ? _data["ruleGroupName"] : <any>null;
            this.modificationField = _data["modificationField"] !== undefined ? _data["modificationField"] : <any>null;
            (<any>this).value = _data["value"] !== undefined ? _data["value"] : <any>null;
            (<any>this).modification = _data["modification"] !== undefined ? _data["modification"] : <any>null;
        }
    }

    static fromJS(data: any): AppliedRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppliedRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleGroupName"] = this.ruleGroupName !== undefined ? this.ruleGroupName : <any>null;
        data["modificationField"] = this.modificationField !== undefined ? this.modificationField : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["modification"] = this.modification !== undefined ? this.modification : <any>null;
        return data;
    }
}

export interface IAppliedRulesDto {
    ruleGroupName?: string | null;
    modificationField?: string | null;
    value?: string | null;
    modification?: string | null;
}

export class Client implements IClient {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    name?: string | null;
    readonly ruleGroups?: RuleGroup[] | null;
    defaultProcessorId?: number;
    defaultProcessor?: RuleProcessor;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["ruleGroups"])) {
                (<any>this).ruleGroups = [] as any;
                for (let item of _data["ruleGroups"])
                    (<any>this).ruleGroups!.push(RuleGroup.fromJS(item));
            }
            else {
                (<any>this).ruleGroups = <any>null;
            }
            this.defaultProcessorId = _data["defaultProcessorId"] !== undefined ? _data["defaultProcessorId"] : <any>null;
            this.defaultProcessor = _data["defaultProcessor"] ? RuleProcessor.fromJS(_data["defaultProcessor"]) : <any>null;
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.ruleGroups)) {
            data["ruleGroups"] = [];
            for (let item of this.ruleGroups)
                data["ruleGroups"].push(item.toJSON());
        }
        data["defaultProcessorId"] = this.defaultProcessorId !== undefined ? this.defaultProcessorId : <any>null;
        data["defaultProcessor"] = this.defaultProcessor ? this.defaultProcessor.toJSON() : <any>null;
        return data;
    }
}

export interface IClient {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    name?: string | null;
    ruleGroups?: RuleGroup[] | null;
    defaultProcessorId?: number;
    defaultProcessor?: RuleProcessor;
}

export class ClientDataExportDto implements IClientDataExportDto {
    clientName?: string | null;
    ruleProcessor?: RuleProcessorExportDto;
    ruleGroups?: RuleGroupExportDto[] | null;

    constructor(data?: IClientDataExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.ruleProcessor = _data["ruleProcessor"] ? RuleProcessorExportDto.fromJS(_data["ruleProcessor"]) : <any>null;
            if (Array.isArray(_data["ruleGroups"])) {
                this.ruleGroups = [] as any;
                for (let item of _data["ruleGroups"])
                    this.ruleGroups!.push(RuleGroupExportDto.fromJS(item));
            }
            else {
                this.ruleGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): ClientDataExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDataExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["ruleProcessor"] = this.ruleProcessor ? this.ruleProcessor.toJSON() : <any>null;
        if (Array.isArray(this.ruleGroups)) {
            data["ruleGroups"] = [];
            for (let item of this.ruleGroups)
                data["ruleGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientDataExportDto {
    clientName?: string | null;
    ruleProcessor?: RuleProcessorExportDto;
    ruleGroups?: RuleGroupExportDto[] | null;
}

export class CreateRuleGroupDto implements ICreateRuleGroupDto {
    name?: string | null;
    description?: string | null;
    isDefault?: boolean;
    modificationFieldId?: number;
    modificationOperationId?: number;
    conditions?: RuleConditionDto[] | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;

    constructor(data?: ICreateRuleGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            this.modificationFieldId = _data["modificationFieldId"] !== undefined ? _data["modificationFieldId"] : <any>null;
            this.modificationOperationId = _data["modificationOperationId"] !== undefined ? _data["modificationOperationId"] : <any>null;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RuleConditionDto.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CreateRuleGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRuleGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        data["modificationFieldId"] = this.modificationFieldId !== undefined ? this.modificationFieldId : <any>null;
        data["modificationOperationId"] = this.modificationOperationId !== undefined ? this.modificationOperationId : <any>null;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>null;
        return data;
    }
}

export interface ICreateRuleGroupDto {
    name?: string | null;
    description?: string | null;
    isDefault?: boolean;
    modificationFieldId?: number;
    modificationOperationId?: number;
    conditions?: RuleConditionDto[] | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;
}

export class FieldDto implements IFieldDto {
    fieldId?: number;
    fieldType?: string | null;
    fieldName?: string | null;
    displayName?: string | null;
    allowedAsCondition?: boolean;
    allowedAsModification?: boolean;
    order?: number;

    constructor(data?: IFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"] !== undefined ? _data["fieldId"] : <any>null;
            this.fieldType = _data["fieldType"] !== undefined ? _data["fieldType"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.allowedAsCondition = _data["allowedAsCondition"] !== undefined ? _data["allowedAsCondition"] : <any>null;
            this.allowedAsModification = _data["allowedAsModification"] !== undefined ? _data["allowedAsModification"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): FieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId !== undefined ? this.fieldId : <any>null;
        data["fieldType"] = this.fieldType !== undefined ? this.fieldType : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["allowedAsCondition"] = this.allowedAsCondition !== undefined ? this.allowedAsCondition : <any>null;
        data["allowedAsModification"] = this.allowedAsModification !== undefined ? this.allowedAsModification : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }
}

export interface IFieldDto {
    fieldId?: number;
    fieldType?: string | null;
    fieldName?: string | null;
    displayName?: string | null;
    allowedAsCondition?: boolean;
    allowedAsModification?: boolean;
    order?: number;
}

export class FieldTypeUsageDto implements IFieldTypeUsageDto {
    fieldType?: string | null;
    forUseInConditions?: boolean;
    forUseInModifications?: boolean;

    constructor(data?: IFieldTypeUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldType = _data["fieldType"] !== undefined ? _data["fieldType"] : <any>null;
            this.forUseInConditions = _data["forUseInConditions"] !== undefined ? _data["forUseInConditions"] : <any>null;
            this.forUseInModifications = _data["forUseInModifications"] !== undefined ? _data["forUseInModifications"] : <any>null;
        }
    }

    static fromJS(data: any): FieldTypeUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldTypeUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType !== undefined ? this.fieldType : <any>null;
        data["forUseInConditions"] = this.forUseInConditions !== undefined ? this.forUseInConditions : <any>null;
        data["forUseInModifications"] = this.forUseInModifications !== undefined ? this.forUseInModifications : <any>null;
        return data;
    }
}

export interface IFieldTypeUsageDto {
    fieldType?: string | null;
    forUseInConditions?: boolean;
    forUseInModifications?: boolean;
}

export class JsonFieldType implements IJsonFieldType {
    id?: number;
    name?: string | null;
    allowedInOperations?: OperationType[] | null;

    constructor(data?: IJsonFieldType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["allowedInOperations"])) {
                this.allowedInOperations = [] as any;
                for (let item of _data["allowedInOperations"])
                    this.allowedInOperations!.push(OperationType.fromJS(item));
            }
            else {
                this.allowedInOperations = <any>null;
            }
        }
    }

    static fromJS(data: any): JsonFieldType {
        data = typeof data === 'object' ? data : {};
        let result = new JsonFieldType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.allowedInOperations)) {
            data["allowedInOperations"] = [];
            for (let item of this.allowedInOperations)
                data["allowedInOperations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJsonFieldType {
    id?: number;
    name?: string | null;
    allowedInOperations?: OperationType[] | null;
}

export enum JsonFieldTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class Metadata implements IMetadata {
    additionalData?: { [key: string]: string; } | null;
    additionalDataHeaders?: string[] | null;
    additionalDataRows?: { [key: string]: string[]; } | null;

    constructor(data?: IMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key] !== undefined ? _data["additionalData"][key] : <any>null;
                }
            }
            else {
                this.additionalData = <any>null;
            }
            if (Array.isArray(_data["additionalDataHeaders"])) {
                this.additionalDataHeaders = [] as any;
                for (let item of _data["additionalDataHeaders"])
                    this.additionalDataHeaders!.push(item);
            }
            else {
                this.additionalDataHeaders = <any>null;
            }
            if (_data["additionalDataRows"]) {
                this.additionalDataRows = {} as any;
                for (let key in _data["additionalDataRows"]) {
                    if (_data["additionalDataRows"].hasOwnProperty(key))
                        (<any>this.additionalDataRows)![key] = _data["additionalDataRows"][key] !== undefined ? _data["additionalDataRows"][key] : [];
                }
            }
            else {
                this.additionalDataRows = <any>null;
            }
        }
    }

    static fromJS(data: any): Metadata {
        data = typeof data === 'object' ? data : {};
        let result = new Metadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = this.additionalData[key] !== undefined ? this.additionalData[key] : <any>null;
            }
        }
        if (Array.isArray(this.additionalDataHeaders)) {
            data["additionalDataHeaders"] = [];
            for (let item of this.additionalDataHeaders)
                data["additionalDataHeaders"].push(item);
        }
        if (this.additionalDataRows) {
            data["additionalDataRows"] = {};
            for (let key in this.additionalDataRows) {
                if (this.additionalDataRows.hasOwnProperty(key))
                    (<any>data["additionalDataRows"])[key] = this.additionalDataRows[key] !== undefined ? this.additionalDataRows[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IMetadata {
    additionalData?: { [key: string]: string; } | null;
    additionalDataHeaders?: string[] | null;
    additionalDataRows?: { [key: string]: string[]; } | null;
}

export class OperationDto implements IOperationDto {
    operationId?: number;
    operationName?: string | null;
    operationDisplay?: string | null;
    allowedAsModification?: boolean;
    allowedAsCondition?: boolean;

    constructor(data?: IOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationId = _data["operationId"] !== undefined ? _data["operationId"] : <any>null;
            this.operationName = _data["operationName"] !== undefined ? _data["operationName"] : <any>null;
            this.operationDisplay = _data["operationDisplay"] !== undefined ? _data["operationDisplay"] : <any>null;
            this.allowedAsModification = _data["allowedAsModification"] !== undefined ? _data["allowedAsModification"] : <any>null;
            this.allowedAsCondition = _data["allowedAsCondition"] !== undefined ? _data["allowedAsCondition"] : <any>null;
        }
    }

    static fromJS(data: any): OperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationId"] = this.operationId !== undefined ? this.operationId : <any>null;
        data["operationName"] = this.operationName !== undefined ? this.operationName : <any>null;
        data["operationDisplay"] = this.operationDisplay !== undefined ? this.operationDisplay : <any>null;
        data["allowedAsModification"] = this.allowedAsModification !== undefined ? this.allowedAsModification : <any>null;
        data["allowedAsCondition"] = this.allowedAsCondition !== undefined ? this.allowedAsCondition : <any>null;
        return data;
    }
}

export interface IOperationDto {
    operationId?: number;
    operationName?: string | null;
    operationDisplay?: string | null;
    allowedAsModification?: boolean;
    allowedAsCondition?: boolean;
}

export class OperationType implements IOperationType {
    id?: number;
    name?: string | null;
    display?: string | null;
    forUseInConditions?: boolean;
    forUseInModifications?: boolean;
    typeID?: number;
    type?: JsonFieldType;

    constructor(data?: IOperationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.display = _data["display"] !== undefined ? _data["display"] : <any>null;
            this.forUseInConditions = _data["forUseInConditions"] !== undefined ? _data["forUseInConditions"] : <any>null;
            this.forUseInModifications = _data["forUseInModifications"] !== undefined ? _data["forUseInModifications"] : <any>null;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : <any>null;
            this.type = _data["type"] ? JsonFieldType.fromJS(_data["type"]) : <any>null;
        }
    }

    static fromJS(data: any): OperationType {
        data = typeof data === 'object' ? data : {};
        let result = new OperationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["display"] = this.display !== undefined ? this.display : <any>null;
        data["forUseInConditions"] = this.forUseInConditions !== undefined ? this.forUseInConditions : <any>null;
        data["forUseInModifications"] = this.forUseInModifications !== undefined ? this.forUseInModifications : <any>null;
        data["typeID"] = this.typeID !== undefined ? this.typeID : <any>null;
        data["type"] = this.type ? this.type.toJSON() : <any>null;
        return data;
    }
}

export interface IOperationType {
    id?: number;
    name?: string | null;
    display?: string | null;
    forUseInConditions?: boolean;
    forUseInModifications?: boolean;
    typeID?: number;
    type?: JsonFieldType;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ProcessorPreviewDto implements IProcessorPreviewDto {
    processorId?: number;
    apiSchema?: string | null;
    apiSample?: string | null;
    apiName?: string | null;

    constructor(data?: IProcessorPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processorId = _data["processorId"] !== undefined ? _data["processorId"] : <any>null;
            this.apiSchema = _data["apiSchema"] !== undefined ? _data["apiSchema"] : <any>null;
            this.apiSample = _data["apiSample"] !== undefined ? _data["apiSample"] : <any>null;
            this.apiName = _data["apiName"] !== undefined ? _data["apiName"] : <any>null;
        }
    }

    static fromJS(data: any): ProcessorPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessorPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processorId"] = this.processorId !== undefined ? this.processorId : <any>null;
        data["apiSchema"] = this.apiSchema !== undefined ? this.apiSchema : <any>null;
        data["apiSample"] = this.apiSample !== undefined ? this.apiSample : <any>null;
        data["apiName"] = this.apiName !== undefined ? this.apiName : <any>null;
        return data;
    }
}

export interface IProcessorPreviewDto {
    processorId?: number;
    apiSchema?: string | null;
    apiSample?: string | null;
    apiName?: string | null;
}

export class ProcessorRequestDto implements IProcessorRequestDto {
    clientName?: string | null;
    processorName?: string | null;
    data?: any | null;
    ruleGroupIds?: number[] | null;

    constructor(data?: IProcessorRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.processorName = _data["processorName"] !== undefined ? _data["processorName"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            if (Array.isArray(_data["ruleGroupIds"])) {
                this.ruleGroupIds = [] as any;
                for (let item of _data["ruleGroupIds"])
                    this.ruleGroupIds!.push(item);
            }
            else {
                this.ruleGroupIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ProcessorRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessorRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["processorName"] = this.processorName !== undefined ? this.processorName : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        if (Array.isArray(this.ruleGroupIds)) {
            data["ruleGroupIds"] = [];
            for (let item of this.ruleGroupIds)
                data["ruleGroupIds"].push(item);
        }
        return data;
    }
}

export interface IProcessorRequestDto {
    clientName?: string | null;
    processorName?: string | null;
    data?: any | null;
    ruleGroupIds?: number[] | null;
}

export class ProcessorResponseDto implements IProcessorResponseDto {
    clientName?: string | null;
    processorName?: string | null;
    originalData?: any | null;
    modifiedData?: any | null;
    appliedRules?: AppliedRulesDto[] | null;

    constructor(data?: IProcessorResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.processorName = _data["processorName"] !== undefined ? _data["processorName"] : <any>null;
            this.originalData = _data["originalData"] !== undefined ? _data["originalData"] : <any>null;
            this.modifiedData = _data["modifiedData"] !== undefined ? _data["modifiedData"] : <any>null;
            if (Array.isArray(_data["appliedRules"])) {
                this.appliedRules = [] as any;
                for (let item of _data["appliedRules"])
                    this.appliedRules!.push(AppliedRulesDto.fromJS(item));
            }
            else {
                this.appliedRules = <any>null;
            }
        }
    }

    static fromJS(data: any): ProcessorResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessorResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["processorName"] = this.processorName !== undefined ? this.processorName : <any>null;
        data["originalData"] = this.originalData !== undefined ? this.originalData : <any>null;
        data["modifiedData"] = this.modifiedData !== undefined ? this.modifiedData : <any>null;
        if (Array.isArray(this.appliedRules)) {
            data["appliedRules"] = [];
            for (let item of this.appliedRules)
                data["appliedRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcessorResponseDto {
    clientName?: string | null;
    processorName?: string | null;
    originalData?: any | null;
    modifiedData?: any | null;
    appliedRules?: AppliedRulesDto[] | null;
}

export class Rule implements IRule {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    name?: string | null;
    ruleEngineExpression?: string | null;
    disabled?: boolean;
    description?: string | null;
    previousVersionID?: number | null;
    previousVersion?: Rule;
    ruleProcessorID?: number;
    ruleProcessor?: RuleProcessor;
    ruleGroupID?: number;
    ruleGroup?: RuleGroup;
    conditions?: RuleCondition[] | null;
    modifications?: RuleModification[] | null;
    appliedInRequests?: APILog[] | null;

    constructor(data?: IRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.ruleEngineExpression = _data["ruleEngineExpression"] !== undefined ? _data["ruleEngineExpression"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.previousVersionID = _data["previousVersionID"] !== undefined ? _data["previousVersionID"] : <any>null;
            this.previousVersion = _data["previousVersion"] ? Rule.fromJS(_data["previousVersion"]) : <any>null;
            this.ruleProcessorID = _data["ruleProcessorID"] !== undefined ? _data["ruleProcessorID"] : <any>null;
            this.ruleProcessor = _data["ruleProcessor"] ? RuleProcessor.fromJS(_data["ruleProcessor"]) : <any>null;
            this.ruleGroupID = _data["ruleGroupID"] !== undefined ? _data["ruleGroupID"] : <any>null;
            this.ruleGroup = _data["ruleGroup"] ? RuleGroup.fromJS(_data["ruleGroup"]) : <any>null;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RuleCondition.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
            if (Array.isArray(_data["modifications"])) {
                this.modifications = [] as any;
                for (let item of _data["modifications"])
                    this.modifications!.push(RuleModification.fromJS(item));
            }
            else {
                this.modifications = <any>null;
            }
            if (Array.isArray(_data["appliedInRequests"])) {
                this.appliedInRequests = [] as any;
                for (let item of _data["appliedInRequests"])
                    this.appliedInRequests!.push(APILog.fromJS(item));
            }
            else {
                this.appliedInRequests = <any>null;
            }
        }
    }

    static fromJS(data: any): Rule {
        data = typeof data === 'object' ? data : {};
        let result = new Rule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["ruleEngineExpression"] = this.ruleEngineExpression !== undefined ? this.ruleEngineExpression : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["previousVersionID"] = this.previousVersionID !== undefined ? this.previousVersionID : <any>null;
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : <any>null;
        data["ruleProcessorID"] = this.ruleProcessorID !== undefined ? this.ruleProcessorID : <any>null;
        data["ruleProcessor"] = this.ruleProcessor ? this.ruleProcessor.toJSON() : <any>null;
        data["ruleGroupID"] = this.ruleGroupID !== undefined ? this.ruleGroupID : <any>null;
        data["ruleGroup"] = this.ruleGroup ? this.ruleGroup.toJSON() : <any>null;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        if (Array.isArray(this.modifications)) {
            data["modifications"] = [];
            for (let item of this.modifications)
                data["modifications"].push(item.toJSON());
        }
        if (Array.isArray(this.appliedInRequests)) {
            data["appliedInRequests"] = [];
            for (let item of this.appliedInRequests)
                data["appliedInRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRule {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    name?: string | null;
    ruleEngineExpression?: string | null;
    disabled?: boolean;
    description?: string | null;
    previousVersionID?: number | null;
    previousVersion?: Rule;
    ruleProcessorID?: number;
    ruleProcessor?: RuleProcessor;
    ruleGroupID?: number;
    ruleGroup?: RuleGroup;
    conditions?: RuleCondition[] | null;
    modifications?: RuleModification[] | null;
    appliedInRequests?: APILog[] | null;
}

export class RuleAssignmentConditionDto implements IRuleAssignmentConditionDto {
    fieldName?: string | null;
    conditionFieldId?: number;
    conditionOperationId?: number;
    conditionValues?: string[] | null;
    isActive?: boolean;
    isExclude?: boolean;

    constructor(data?: IRuleAssignmentConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.conditionFieldId = _data["conditionFieldId"] !== undefined ? _data["conditionFieldId"] : <any>null;
            this.conditionOperationId = _data["conditionOperationId"] !== undefined ? _data["conditionOperationId"] : <any>null;
            if (Array.isArray(_data["conditionValues"])) {
                this.conditionValues = [] as any;
                for (let item of _data["conditionValues"])
                    this.conditionValues!.push(item);
            }
            else {
                this.conditionValues = <any>null;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isExclude = _data["isExclude"] !== undefined ? _data["isExclude"] : <any>null;
        }
    }

    static fromJS(data: any): RuleAssignmentConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleAssignmentConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["conditionFieldId"] = this.conditionFieldId !== undefined ? this.conditionFieldId : <any>null;
        data["conditionOperationId"] = this.conditionOperationId !== undefined ? this.conditionOperationId : <any>null;
        if (Array.isArray(this.conditionValues)) {
            data["conditionValues"] = [];
            for (let item of this.conditionValues)
                data["conditionValues"].push(item);
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isExclude"] = this.isExclude !== undefined ? this.isExclude : <any>null;
        return data;
    }
}

export interface IRuleAssignmentConditionDto {
    fieldName?: string | null;
    conditionFieldId?: number;
    conditionOperationId?: number;
    conditionValues?: string[] | null;
    isActive?: boolean;
    isExclude?: boolean;
}

export class RuleAssignmentDto implements IRuleAssignmentDto {
    conditions!: RuleAssignmentConditionDto[];
    modificationValue?: string | null;

    constructor(data?: IRuleAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RuleAssignmentConditionDto.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
            this.modificationValue = _data["modificationValue"] !== undefined ? _data["modificationValue"] : <any>null;
        }
    }

    static fromJS(data: any): RuleAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        data["modificationValue"] = this.modificationValue !== undefined ? this.modificationValue : <any>null;
        return data;
    }
}

export interface IRuleAssignmentDto {
    conditions: RuleAssignmentConditionDto[];
    modificationValue?: string | null;
}

export class RuleBuilderFieldDto implements IRuleBuilderFieldDto {
    fieldId?: number;
    fieldName?: string | null;
    displayName?: string | null;
    fieldType?: string | null;
    availableOperations?: OperationDto[] | null;

    constructor(data?: IRuleBuilderFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"] !== undefined ? _data["fieldId"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.fieldType = _data["fieldType"] !== undefined ? _data["fieldType"] : <any>null;
            if (Array.isArray(_data["availableOperations"])) {
                this.availableOperations = [] as any;
                for (let item of _data["availableOperations"])
                    this.availableOperations!.push(OperationDto.fromJS(item));
            }
            else {
                this.availableOperations = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleBuilderFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleBuilderFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId !== undefined ? this.fieldId : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["fieldType"] = this.fieldType !== undefined ? this.fieldType : <any>null;
        if (Array.isArray(this.availableOperations)) {
            data["availableOperations"] = [];
            for (let item of this.availableOperations)
                data["availableOperations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleBuilderFieldDto {
    fieldId?: number;
    fieldName?: string | null;
    displayName?: string | null;
    fieldType?: string | null;
    availableOperations?: OperationDto[] | null;
}

export class RuleBuilderOptionsDto implements IRuleBuilderOptionsDto {
    conditions?: RuleBuilderFieldDto[] | null;
    modifications?: RuleBuilderFieldDto[] | null;

    constructor(data?: IRuleBuilderOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RuleBuilderFieldDto.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
            if (Array.isArray(_data["modifications"])) {
                this.modifications = [] as any;
                for (let item of _data["modifications"])
                    this.modifications!.push(RuleBuilderFieldDto.fromJS(item));
            }
            else {
                this.modifications = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleBuilderOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleBuilderOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        if (Array.isArray(this.modifications)) {
            data["modifications"] = [];
            for (let item of this.modifications)
                data["modifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleBuilderOptionsDto {
    conditions?: RuleBuilderFieldDto[] | null;
    modifications?: RuleBuilderFieldDto[] | null;
}

export class RuleCondition implements IRuleCondition {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    value?: string | null;
    isActive?: boolean;
    isExclude?: boolean;
    fieldID?: number | null;
    field?: RuleProcessorField;
    operationID?: number | null;
    operation?: OperationType;

    constructor(data?: IRuleCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isExclude = _data["isExclude"] !== undefined ? _data["isExclude"] : <any>null;
            this.fieldID = _data["fieldID"] !== undefined ? _data["fieldID"] : <any>null;
            this.field = _data["field"] ? RuleProcessorField.fromJS(_data["field"]) : <any>null;
            this.operationID = _data["operationID"] !== undefined ? _data["operationID"] : <any>null;
            this.operation = _data["operation"] ? OperationType.fromJS(_data["operation"]) : <any>null;
        }
    }

    static fromJS(data: any): RuleCondition {
        data = typeof data === 'object' ? data : {};
        let result = new RuleCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isExclude"] = this.isExclude !== undefined ? this.isExclude : <any>null;
        data["fieldID"] = this.fieldID !== undefined ? this.fieldID : <any>null;
        data["field"] = this.field ? this.field.toJSON() : <any>null;
        data["operationID"] = this.operationID !== undefined ? this.operationID : <any>null;
        data["operation"] = this.operation ? this.operation.toJSON() : <any>null;
        return data;
    }
}

export interface IRuleCondition {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    value?: string | null;
    isActive?: boolean;
    isExclude?: boolean;
    fieldID?: number | null;
    field?: RuleProcessorField;
    operationID?: number | null;
    operation?: OperationType;
}

export class RuleConditionDto implements IRuleConditionDto {
    conditionFieldId?: number;
    conditionOperationId?: number;

    constructor(data?: IRuleConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionFieldId = _data["conditionFieldId"] !== undefined ? _data["conditionFieldId"] : <any>null;
            this.conditionOperationId = _data["conditionOperationId"] !== undefined ? _data["conditionOperationId"] : <any>null;
        }
    }

    static fromJS(data: any): RuleConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionFieldId"] = this.conditionFieldId !== undefined ? this.conditionFieldId : <any>null;
        data["conditionOperationId"] = this.conditionOperationId !== undefined ? this.conditionOperationId : <any>null;
        return data;
    }
}

export interface IRuleConditionDto {
    conditionFieldId?: number;
    conditionOperationId?: number;
}

export class RuleConditionExportDto implements IRuleConditionExportDto {
    value?: string | null;
    fieldName?: string | null;
    operationName?: string | null;

    constructor(data?: IRuleConditionExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.operationName = _data["operationName"] !== undefined ? _data["operationName"] : <any>null;
        }
    }

    static fromJS(data: any): RuleConditionExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleConditionExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["operationName"] = this.operationName !== undefined ? this.operationName : <any>null;
        return data;
    }
}

export interface IRuleConditionExportDto {
    value?: string | null;
    fieldName?: string | null;
    operationName?: string | null;
}

export class RuleExportDto implements IRuleExportDto {
    name?: string | null;
    ruleEngineExpression?: string | null;
    disabled?: boolean;
    description?: string | null;
    conditions?: RuleConditionExportDto[] | null;
    modifications?: RuleModificationExportDto[] | null;

    constructor(data?: IRuleExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.ruleEngineExpression = _data["ruleEngineExpression"] !== undefined ? _data["ruleEngineExpression"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RuleConditionExportDto.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
            if (Array.isArray(_data["modifications"])) {
                this.modifications = [] as any;
                for (let item of _data["modifications"])
                    this.modifications!.push(RuleModificationExportDto.fromJS(item));
            }
            else {
                this.modifications = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["ruleEngineExpression"] = this.ruleEngineExpression !== undefined ? this.ruleEngineExpression : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        if (Array.isArray(this.modifications)) {
            data["modifications"] = [];
            for (let item of this.modifications)
                data["modifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleExportDto {
    name?: string | null;
    ruleEngineExpression?: string | null;
    disabled?: boolean;
    description?: string | null;
    conditions?: RuleConditionExportDto[] | null;
    modifications?: RuleModificationExportDto[] | null;
}

export class RuleGroup implements IRuleGroup {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    urlId?: number | null;
    name?: string | null;
    description?: string | null;
    clientID?: number;
    client?: Client;
    previousVersionID?: number | null;
    previousVersion?: RuleGroup;
    rules?: Rule[] | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;

    constructor(data?: IRuleGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.urlId = _data["urlId"] !== undefined ? _data["urlId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.previousVersionID = _data["previousVersionID"] !== undefined ? _data["previousVersionID"] : <any>null;
            this.previousVersion = _data["previousVersion"] ? RuleGroup.fromJS(_data["previousVersion"]) : <any>null;
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(Rule.fromJS(item));
            }
            else {
                this.rules = <any>null;
            }
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): RuleGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["urlId"] = this.urlId !== undefined ? this.urlId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["clientID"] = this.clientID !== undefined ? this.clientID : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["previousVersionID"] = this.previousVersionID !== undefined ? this.previousVersionID : <any>null;
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : <any>null;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>null;
        return data;
    }
}

export interface IRuleGroup {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    urlId?: number | null;
    name?: string | null;
    description?: string | null;
    clientID?: number;
    client?: Client;
    previousVersionID?: number | null;
    previousVersion?: RuleGroup;
    rules?: Rule[] | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;
}

export class RuleGroupAssignmentConditionDto implements IRuleGroupAssignmentConditionDto {
    readonly conditionValues?: string[] | null;
    conditionOperationId?: number | null;
    conditionField?: string | null;
    conditionFieldId?: number | null;
    isActive?: boolean;
    isExclude?: boolean;

    constructor(data?: IRuleGroupAssignmentConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditionValues"])) {
                (<any>this).conditionValues = [] as any;
                for (let item of _data["conditionValues"])
                    (<any>this).conditionValues!.push(item);
            }
            else {
                (<any>this).conditionValues = <any>null;
            }
            this.conditionOperationId = _data["conditionOperationId"] !== undefined ? _data["conditionOperationId"] : <any>null;
            this.conditionField = _data["conditionField"] !== undefined ? _data["conditionField"] : <any>null;
            this.conditionFieldId = _data["conditionFieldId"] !== undefined ? _data["conditionFieldId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isExclude = _data["isExclude"] !== undefined ? _data["isExclude"] : <any>null;
        }
    }

    static fromJS(data: any): RuleGroupAssignmentConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGroupAssignmentConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditionValues)) {
            data["conditionValues"] = [];
            for (let item of this.conditionValues)
                data["conditionValues"].push(item);
        }
        data["conditionOperationId"] = this.conditionOperationId !== undefined ? this.conditionOperationId : <any>null;
        data["conditionField"] = this.conditionField !== undefined ? this.conditionField : <any>null;
        data["conditionFieldId"] = this.conditionFieldId !== undefined ? this.conditionFieldId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isExclude"] = this.isExclude !== undefined ? this.isExclude : <any>null;
        return data;
    }
}

export interface IRuleGroupAssignmentConditionDto {
    conditionValues?: string[] | null;
    conditionOperationId?: number | null;
    conditionField?: string | null;
    conditionFieldId?: number | null;
    isActive?: boolean;
    isExclude?: boolean;
}

export class RuleGroupAssignmentDto implements IRuleGroupAssignmentDto {
    readonly modificationValue?: string | null;
    modificationOperationId?: number;
    conditions?: RuleGroupAssignmentConditionDto[] | null;

    constructor(data?: IRuleGroupAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).modificationValue = _data["modificationValue"] !== undefined ? _data["modificationValue"] : <any>null;
            this.modificationOperationId = _data["modificationOperationId"] !== undefined ? _data["modificationOperationId"] : <any>null;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RuleGroupAssignmentConditionDto.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleGroupAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGroupAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modificationValue"] = this.modificationValue !== undefined ? this.modificationValue : <any>null;
        data["modificationOperationId"] = this.modificationOperationId !== undefined ? this.modificationOperationId : <any>null;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleGroupAssignmentDto {
    modificationValue?: string | null;
    modificationOperationId?: number;
    conditions?: RuleGroupAssignmentConditionDto[] | null;
}

export class RuleGroupDisplayDto implements IRuleGroupDisplayDto {
    id?: number;
    name?: string | null;
    readonly description?: string | null;
    isDefault?: boolean;
    lastUpdatedDate?: DateTime;
    lastUpdatedUserName?: string | null;
    template?: RuleGroupTemplateDto;
    ruleAssignments?: RuleGroupAssignmentDto[] | null;
    defaultAssignment?: RuleGroupAssignmentDto;
    defaultRuleGroup?: RuleGroupDisplayDto;
    readonly url?: string | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;
    readonly isInactive?: boolean;
    readonly isActive?: boolean;

    constructor(data?: IRuleGroupDisplayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            (<any>this).description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? DateTime.fromISO(_data["lastUpdatedDate"].toString()) : <any>null;
            this.lastUpdatedUserName = _data["lastUpdatedUserName"] !== undefined ? _data["lastUpdatedUserName"] : <any>null;
            this.template = _data["template"] ? RuleGroupTemplateDto.fromJS(_data["template"]) : <any>null;
            if (Array.isArray(_data["ruleAssignments"])) {
                this.ruleAssignments = [] as any;
                for (let item of _data["ruleAssignments"])
                    this.ruleAssignments!.push(RuleGroupAssignmentDto.fromJS(item));
            }
            else {
                this.ruleAssignments = <any>null;
            }
            this.defaultAssignment = _data["defaultAssignment"] ? RuleGroupAssignmentDto.fromJS(_data["defaultAssignment"]) : <any>null;
            this.defaultRuleGroup = _data["defaultRuleGroup"] ? RuleGroupDisplayDto.fromJS(_data["defaultRuleGroup"]) : <any>null;
            (<any>this).url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>null;
            (<any>this).isInactive = _data["isInactive"] !== undefined ? _data["isInactive"] : <any>null;
            (<any>this).isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): RuleGroupDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGroupDisplayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toString() : <any>null;
        data["lastUpdatedUserName"] = this.lastUpdatedUserName !== undefined ? this.lastUpdatedUserName : <any>null;
        data["template"] = this.template ? this.template.toJSON() : <any>null;
        if (Array.isArray(this.ruleAssignments)) {
            data["ruleAssignments"] = [];
            for (let item of this.ruleAssignments)
                data["ruleAssignments"].push(item.toJSON());
        }
        data["defaultAssignment"] = this.defaultAssignment ? this.defaultAssignment.toJSON() : <any>null;
        data["defaultRuleGroup"] = this.defaultRuleGroup ? this.defaultRuleGroup.toJSON() : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>null;
        data["isInactive"] = this.isInactive !== undefined ? this.isInactive : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IRuleGroupDisplayDto {
    id?: number;
    name?: string | null;
    description?: string | null;
    isDefault?: boolean;
    lastUpdatedDate?: DateTime;
    lastUpdatedUserName?: string | null;
    template?: RuleGroupTemplateDto;
    ruleAssignments?: RuleGroupAssignmentDto[] | null;
    defaultAssignment?: RuleGroupAssignmentDto;
    defaultRuleGroup?: RuleGroupDisplayDto;
    url?: string | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;
    isInactive?: boolean;
    isActive?: boolean;
}

export class RuleGroupExportDto implements IRuleGroupExportDto {
    name?: string | null;
    description?: string | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;
    rules?: RuleExportDto[] | null;

    constructor(data?: IRuleGroupExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleExportDto.fromJS(item));
            }
            else {
                this.rules = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleGroupExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGroupExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>null;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleGroupExportDto {
    name?: string | null;
    description?: string | null;
    startDate?: DateTime | null;
    endDate?: DateTime | null;
    rules?: RuleExportDto[] | null;
}

export class RuleGroupTemplateConditionDto implements IRuleGroupTemplateConditionDto {
    conditionField?: string | null;
    conditionFieldId?: number | null;
    conditionOperation?: string | null;
    conditionOperationId?: number | null;

    constructor(data?: IRuleGroupTemplateConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionField = _data["conditionField"] !== undefined ? _data["conditionField"] : <any>null;
            this.conditionFieldId = _data["conditionFieldId"] !== undefined ? _data["conditionFieldId"] : <any>null;
            this.conditionOperation = _data["conditionOperation"] !== undefined ? _data["conditionOperation"] : <any>null;
            this.conditionOperationId = _data["conditionOperationId"] !== undefined ? _data["conditionOperationId"] : <any>null;
        }
    }

    static fromJS(data: any): RuleGroupTemplateConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGroupTemplateConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionField"] = this.conditionField !== undefined ? this.conditionField : <any>null;
        data["conditionFieldId"] = this.conditionFieldId !== undefined ? this.conditionFieldId : <any>null;
        data["conditionOperation"] = this.conditionOperation !== undefined ? this.conditionOperation : <any>null;
        data["conditionOperationId"] = this.conditionOperationId !== undefined ? this.conditionOperationId : <any>null;
        return data;
    }
}

export interface IRuleGroupTemplateConditionDto {
    conditionField?: string | null;
    conditionFieldId?: number | null;
    conditionOperation?: string | null;
    conditionOperationId?: number | null;
}

export class RuleGroupTemplateDto implements IRuleGroupTemplateDto {
    modificationField?: string | null;
    modificationOperation?: string | null;
    modificationOperationId?: number;
    conditions?: RuleGroupTemplateConditionDto[] | null;

    constructor(data?: IRuleGroupTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modificationField = _data["modificationField"] !== undefined ? _data["modificationField"] : <any>null;
            this.modificationOperation = _data["modificationOperation"] !== undefined ? _data["modificationOperation"] : <any>null;
            this.modificationOperationId = _data["modificationOperationId"] !== undefined ? _data["modificationOperationId"] : <any>null;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RuleGroupTemplateConditionDto.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleGroupTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGroupTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modificationField"] = this.modificationField !== undefined ? this.modificationField : <any>null;
        data["modificationOperation"] = this.modificationOperation !== undefined ? this.modificationOperation : <any>null;
        data["modificationOperationId"] = this.modificationOperationId !== undefined ? this.modificationOperationId : <any>null;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleGroupTemplateDto {
    modificationField?: string | null;
    modificationOperation?: string | null;
    modificationOperationId?: number;
    conditions?: RuleGroupTemplateConditionDto[] | null;
}

export class RuleLogDto implements IRuleLogDto {
    readonly updatedBy?: string | null;
    readonly isActive?: boolean;
    readonly activeFrom?: DateTime;
    readonly activeTo?: DateTime | null;
    readonly ruleGroupName?: string | null;
    readonly isDefault?: boolean;
    readonly url?: string | null;
    readonly conditionField?: string | null;
    readonly conditionOperation?: string | null;
    readonly conditionValues?: string[] | null;
    readonly modificationField?: string | null;
    readonly modificationOperation?: string | null;
    readonly modificationValue?: string | null;
    readonly modificationString?: string | null;
    readonly modificationLogString?: string | null;

    constructor(data?: IRuleLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            (<any>this).isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            (<any>this).activeFrom = _data["activeFrom"] ? DateTime.fromISO(_data["activeFrom"].toString()) : <any>null;
            (<any>this).activeTo = _data["activeTo"] ? DateTime.fromISO(_data["activeTo"].toString()) : <any>null;
            (<any>this).ruleGroupName = _data["ruleGroupName"] !== undefined ? _data["ruleGroupName"] : <any>null;
            (<any>this).isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            (<any>this).url = _data["url"] !== undefined ? _data["url"] : <any>null;
            (<any>this).conditionField = _data["conditionField"] !== undefined ? _data["conditionField"] : <any>null;
            (<any>this).conditionOperation = _data["conditionOperation"] !== undefined ? _data["conditionOperation"] : <any>null;
            if (Array.isArray(_data["conditionValues"])) {
                (<any>this).conditionValues = [] as any;
                for (let item of _data["conditionValues"])
                    (<any>this).conditionValues!.push(item);
            }
            else {
                (<any>this).conditionValues = <any>null;
            }
            (<any>this).modificationField = _data["modificationField"] !== undefined ? _data["modificationField"] : <any>null;
            (<any>this).modificationOperation = _data["modificationOperation"] !== undefined ? _data["modificationOperation"] : <any>null;
            (<any>this).modificationValue = _data["modificationValue"] !== undefined ? _data["modificationValue"] : <any>null;
            (<any>this).modificationString = _data["modificationString"] !== undefined ? _data["modificationString"] : <any>null;
            (<any>this).modificationLogString = _data["modificationLogString"] !== undefined ? _data["modificationLogString"] : <any>null;
        }
    }

    static fromJS(data: any): RuleLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toString() : <any>null;
        data["activeTo"] = this.activeTo ? this.activeTo.toString() : <any>null;
        data["ruleGroupName"] = this.ruleGroupName !== undefined ? this.ruleGroupName : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["conditionField"] = this.conditionField !== undefined ? this.conditionField : <any>null;
        data["conditionOperation"] = this.conditionOperation !== undefined ? this.conditionOperation : <any>null;
        if (Array.isArray(this.conditionValues)) {
            data["conditionValues"] = [];
            for (let item of this.conditionValues)
                data["conditionValues"].push(item);
        }
        data["modificationField"] = this.modificationField !== undefined ? this.modificationField : <any>null;
        data["modificationOperation"] = this.modificationOperation !== undefined ? this.modificationOperation : <any>null;
        data["modificationValue"] = this.modificationValue !== undefined ? this.modificationValue : <any>null;
        data["modificationString"] = this.modificationString !== undefined ? this.modificationString : <any>null;
        data["modificationLogString"] = this.modificationLogString !== undefined ? this.modificationLogString : <any>null;
        return data;
    }
}

export interface IRuleLogDto {
    updatedBy?: string | null;
    isActive?: boolean;
    activeFrom?: DateTime;
    activeTo?: DateTime | null;
    ruleGroupName?: string | null;
    isDefault?: boolean;
    url?: string | null;
    conditionField?: string | null;
    conditionOperation?: string | null;
    conditionValues?: string[] | null;
    modificationField?: string | null;
    modificationOperation?: string | null;
    modificationValue?: string | null;
    modificationString?: string | null;
    modificationLogString?: string | null;
}

export class RuleModification implements IRuleModification {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    value?: string | null;
    fieldID?: number;
    field?: RuleProcessorField;
    operationID?: number;
    operation?: OperationType;

    constructor(data?: IRuleModification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.fieldID = _data["fieldID"] !== undefined ? _data["fieldID"] : <any>null;
            this.field = _data["field"] ? RuleProcessorField.fromJS(_data["field"]) : <any>null;
            this.operationID = _data["operationID"] !== undefined ? _data["operationID"] : <any>null;
            this.operation = _data["operation"] ? OperationType.fromJS(_data["operation"]) : <any>null;
        }
    }

    static fromJS(data: any): RuleModification {
        data = typeof data === 'object' ? data : {};
        let result = new RuleModification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["fieldID"] = this.fieldID !== undefined ? this.fieldID : <any>null;
        data["field"] = this.field ? this.field.toJSON() : <any>null;
        data["operationID"] = this.operationID !== undefined ? this.operationID : <any>null;
        data["operation"] = this.operation ? this.operation.toJSON() : <any>null;
        return data;
    }
}

export interface IRuleModification {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    value?: string | null;
    fieldID?: number;
    field?: RuleProcessorField;
    operationID?: number;
    operation?: OperationType;
}

export class RuleModificationExportDto implements IRuleModificationExportDto {
    value?: string | null;
    fieldName?: string | null;
    operationName?: string | null;

    constructor(data?: IRuleModificationExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.operationName = _data["operationName"] !== undefined ? _data["operationName"] : <any>null;
        }
    }

    static fromJS(data: any): RuleModificationExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleModificationExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["operationName"] = this.operationName !== undefined ? this.operationName : <any>null;
        return data;
    }
}

export interface IRuleModificationExportDto {
    value?: string | null;
    fieldName?: string | null;
    operationName?: string | null;
}

export class RuleProcessor implements IRuleProcessor {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    name?: string | null;
    apiName?: string | null;
    apiSchema?: string | null;
    apiSample?: string | null;
    readonly fields?: RuleProcessorField[] | null;

    constructor(data?: IRuleProcessor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.apiName = _data["apiName"] !== undefined ? _data["apiName"] : <any>null;
            this.apiSchema = _data["apiSchema"] !== undefined ? _data["apiSchema"] : <any>null;
            this.apiSample = _data["apiSample"] !== undefined ? _data["apiSample"] : <any>null;
            if (Array.isArray(_data["fields"])) {
                (<any>this).fields = [] as any;
                for (let item of _data["fields"])
                    (<any>this).fields!.push(RuleProcessorField.fromJS(item));
            }
            else {
                (<any>this).fields = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleProcessor {
        data = typeof data === 'object' ? data : {};
        let result = new RuleProcessor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["apiName"] = this.apiName !== undefined ? this.apiName : <any>null;
        data["apiSchema"] = this.apiSchema !== undefined ? this.apiSchema : <any>null;
        data["apiSample"] = this.apiSample !== undefined ? this.apiSample : <any>null;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleProcessor {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    name?: string | null;
    apiName?: string | null;
    apiSchema?: string | null;
    apiSample?: string | null;
    fields?: RuleProcessorField[] | null;
}

export class RuleProcessorExportDto implements IRuleProcessorExportDto {
    name?: string | null;
    apiName?: string | null;
    apiSchema?: string | null;
    apiSample?: string | null;
    fields?: RuleProcessorFieldExportDto[] | null;

    constructor(data?: IRuleProcessorExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.apiName = _data["apiName"] !== undefined ? _data["apiName"] : <any>null;
            this.apiSchema = _data["apiSchema"] !== undefined ? _data["apiSchema"] : <any>null;
            this.apiSample = _data["apiSample"] !== undefined ? _data["apiSample"] : <any>null;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(RuleProcessorFieldExportDto.fromJS(item));
            }
            else {
                this.fields = <any>null;
            }
        }
    }

    static fromJS(data: any): RuleProcessorExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleProcessorExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["apiName"] = this.apiName !== undefined ? this.apiName : <any>null;
        data["apiSchema"] = this.apiSchema !== undefined ? this.apiSchema : <any>null;
        data["apiSample"] = this.apiSample !== undefined ? this.apiSample : <any>null;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleProcessorExportDto {
    name?: string | null;
    apiName?: string | null;
    apiSchema?: string | null;
    apiSample?: string | null;
    fields?: RuleProcessorFieldExportDto[] | null;
}

export class RuleProcessorField implements IRuleProcessorField {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    jsonField?: string | null;
    jsonFieldTypeID?: number;
    jsonFieldType?: JsonFieldType;
    friendlyName?: string | null;
    allowCondition?: boolean;
    allowModification?: boolean;
    ruleProcessorID?: number;
    ruleProcessor?: RuleProcessor;
    order?: number;

    constructor(data?: IRuleProcessorField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.jsonField = _data["jsonField"] !== undefined ? _data["jsonField"] : <any>null;
            this.jsonFieldTypeID = _data["jsonFieldTypeID"] !== undefined ? _data["jsonFieldTypeID"] : <any>null;
            this.jsonFieldType = _data["jsonFieldType"] ? JsonFieldType.fromJS(_data["jsonFieldType"]) : <any>null;
            this.friendlyName = _data["friendlyName"] !== undefined ? _data["friendlyName"] : <any>null;
            this.allowCondition = _data["allowCondition"] !== undefined ? _data["allowCondition"] : <any>null;
            this.allowModification = _data["allowModification"] !== undefined ? _data["allowModification"] : <any>null;
            this.ruleProcessorID = _data["ruleProcessorID"] !== undefined ? _data["ruleProcessorID"] : <any>null;
            this.ruleProcessor = _data["ruleProcessor"] ? RuleProcessor.fromJS(_data["ruleProcessor"]) : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): RuleProcessorField {
        data = typeof data === 'object' ? data : {};
        let result = new RuleProcessorField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["jsonField"] = this.jsonField !== undefined ? this.jsonField : <any>null;
        data["jsonFieldTypeID"] = this.jsonFieldTypeID !== undefined ? this.jsonFieldTypeID : <any>null;
        data["jsonFieldType"] = this.jsonFieldType ? this.jsonFieldType.toJSON() : <any>null;
        data["friendlyName"] = this.friendlyName !== undefined ? this.friendlyName : <any>null;
        data["allowCondition"] = this.allowCondition !== undefined ? this.allowCondition : <any>null;
        data["allowModification"] = this.allowModification !== undefined ? this.allowModification : <any>null;
        data["ruleProcessorID"] = this.ruleProcessorID !== undefined ? this.ruleProcessorID : <any>null;
        data["ruleProcessor"] = this.ruleProcessor ? this.ruleProcessor.toJSON() : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }
}

export interface IRuleProcessorField {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    jsonField?: string | null;
    jsonFieldTypeID?: number;
    jsonFieldType?: JsonFieldType;
    friendlyName?: string | null;
    allowCondition?: boolean;
    allowModification?: boolean;
    ruleProcessorID?: number;
    ruleProcessor?: RuleProcessor;
    order?: number;
}

export class RuleProcessorFieldExportDto implements IRuleProcessorFieldExportDto {
    name?: string | null;
    jsonField?: string | null;
    jsonFieldType?: string | null;
    allowCondition?: boolean;
    allowModification?: boolean;

    constructor(data?: IRuleProcessorFieldExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.jsonField = _data["jsonField"] !== undefined ? _data["jsonField"] : <any>null;
            this.jsonFieldType = _data["jsonFieldType"] !== undefined ? _data["jsonFieldType"] : <any>null;
            this.allowCondition = _data["allowCondition"] !== undefined ? _data["allowCondition"] : <any>null;
            this.allowModification = _data["allowModification"] !== undefined ? _data["allowModification"] : <any>null;
        }
    }

    static fromJS(data: any): RuleProcessorFieldExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleProcessorFieldExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["jsonField"] = this.jsonField !== undefined ? this.jsonField : <any>null;
        data["jsonFieldType"] = this.jsonFieldType !== undefined ? this.jsonFieldType : <any>null;
        data["allowCondition"] = this.allowCondition !== undefined ? this.allowCondition : <any>null;
        data["allowModification"] = this.allowModification !== undefined ? this.allowModification : <any>null;
        return data;
    }
}

export interface IRuleProcessorFieldExportDto {
    name?: string | null;
    jsonField?: string | null;
    jsonFieldType?: string | null;
    allowCondition?: boolean;
    allowModification?: boolean;
}

export class UpdateRuleGroupDto implements IUpdateRuleGroupDto {
    id?: number;
    ruleAssignments?: RuleAssignmentDto[] | null;
    defaultRuleAssignment?: RuleAssignmentDto;
    startDate?: DateTime | null;
    endDate?: DateTime | null;

    constructor(data?: IUpdateRuleGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["ruleAssignments"])) {
                this.ruleAssignments = [] as any;
                for (let item of _data["ruleAssignments"])
                    this.ruleAssignments!.push(RuleAssignmentDto.fromJS(item));
            }
            else {
                this.ruleAssignments = <any>null;
            }
            this.defaultRuleAssignment = _data["defaultRuleAssignment"] ? RuleAssignmentDto.fromJS(_data["defaultRuleAssignment"]) : <any>null;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UpdateRuleGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRuleGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.ruleAssignments)) {
            data["ruleAssignments"] = [];
            for (let item of this.ruleAssignments)
                data["ruleAssignments"].push(item.toJSON());
        }
        data["defaultRuleAssignment"] = this.defaultRuleAssignment ? this.defaultRuleAssignment.toJSON() : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>null;
        return data;
    }
}

export interface IUpdateRuleGroupDto {
    id?: number;
    ruleAssignments?: RuleAssignmentDto[] | null;
    defaultRuleAssignment?: RuleAssignmentDto;
    startDate?: DateTime | null;
    endDate?: DateTime | null;
}

export class User implements IUser {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    userName?: string | null;
    oktaID?: string | null;
    clientID?: number | null;
    client?: Client;
    apiKey?: string | null;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>null;
            this.createdByID = _data["createdByID"] !== undefined ? _data["createdByID"] : <any>null;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>null;
            this.lastUpdatedOnUtc = _data["lastUpdatedOnUtc"] ? DateTime.fromISO(_data["lastUpdatedOnUtc"].toString()) : <any>null;
            this.lastUpdatedByID = _data["lastUpdatedByID"] !== undefined ? _data["lastUpdatedByID"] : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] ? User.fromJS(_data["lastUpdatedBy"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.oktaID = _data["oktaID"] !== undefined ? _data["oktaID"] : <any>null;
            this.clientID = _data["clientID"] !== undefined ? _data["clientID"] : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.apiKey = _data["apiKey"] !== undefined ? _data["apiKey"] : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>null;
        data["createdByID"] = this.createdByID !== undefined ? this.createdByID : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["lastUpdatedOnUtc"] = this.lastUpdatedOnUtc ? this.lastUpdatedOnUtc.toString() : <any>null;
        data["lastUpdatedByID"] = this.lastUpdatedByID !== undefined ? this.lastUpdatedByID : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy ? this.lastUpdatedBy.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["oktaID"] = this.oktaID !== undefined ? this.oktaID : <any>null;
        data["clientID"] = this.clientID !== undefined ? this.clientID : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["apiKey"] = this.apiKey !== undefined ? this.apiKey : <any>null;
        return data;
    }
}

export interface IUser {
    id?: number;
    createdOnUtc?: DateTime;
    createdByID?: number;
    createdBy?: User;
    lastUpdatedOnUtc?: DateTime;
    lastUpdatedByID?: number;
    lastUpdatedBy?: User;
    isDeleted?: boolean;
    userName?: string | null;
    oktaID?: string | null;
    clientID?: number | null;
    client?: Client;
    apiKey?: string | null;
}

export class UserDto implements IUserDto {
    id?: number;
    userName?: string | null;
    clientId?: number | null;
    clientName?: string | null;
    defaultProcessorId?: number | null;
    defaultProcessorName?: string | null;
    apiKey?: string | null;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.defaultProcessorId = _data["defaultProcessorId"] !== undefined ? _data["defaultProcessorId"] : <any>null;
            this.defaultProcessorName = _data["defaultProcessorName"] !== undefined ? _data["defaultProcessorName"] : <any>null;
            this.apiKey = _data["apiKey"] !== undefined ? _data["apiKey"] : <any>null;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["defaultProcessorId"] = this.defaultProcessorId !== undefined ? this.defaultProcessorId : <any>null;
        data["defaultProcessorName"] = this.defaultProcessorName !== undefined ? this.defaultProcessorName : <any>null;
        data["apiKey"] = this.apiKey !== undefined ? this.apiKey : <any>null;
        return data;
    }
}

export interface IUserDto {
    id?: number;
    userName?: string | null;
    clientId?: number | null;
    clientName?: string | null;
    defaultProcessorId?: number | null;
    defaultProcessorName?: string | null;
    apiKey?: string | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}